import request from '@/utils/request'


export function fechListUserBookLesson(data) {
  return request({
    url: '/admin/booklesson/qlUserBookLesson',
    method: 'post',
    data: data
  })

}

//店铺帮忙预约
export function adminBookLesson(params) {
  return request({
    url: '/admin/booklesson/adminBookLesson',
    method: 'get',
    params: params
  })

}

//未到签到补课约定
export function adminNotAttendBookLesson(params) {
  return request({
    url: '/admin/booklesson/adminNotAttendBookLesson',
    method: 'get',
    params: params
  })

}

//取消固定预约
export function cancelPOST(params) {
  return request({
    url: '/admin/regular/cancel',
    method: 'get',
    params: params
  })

}





export function passbook(params) {
  return request({
    url: '/admin/booklesson/passbook',
    method: 'get',
    params: params
  })
}

/**
 * 批量通过审核
 * @param params
 */
export function batchAdminPassBook(data) {
  return request({
    url: '/admin/booklesson/batchAdminPassBook',
    method: 'post',
    data: data
  })
}


export function adminSign(params) {
  return request({
    url: '/admin/booklesson/sign',
    method: 'get',
    params: params
  })
}
//通过门店id和店铺模板id查询规则
export function findTemplateById(params) {
  return request({
    url: '/admin/store/findTemplateById',
    method: 'get',
    params: params
  })
}
//批量取消
export function batcheCancelBook(data) {
  return request({
    url: '/admin/user/lessons/batcheCancelBook',
    method: 'post',
    data: data
  })
}
//参数配置
export function updateTemplateSetting(data) {
  return request({
    url: '/admin/store/updateTemplateSetting',
    method: 'post',
    data: data
  })
}
//批量签到
export function batcheSingIn(data) {
  return request({
    url: '/admin/user/lessons/batcheSingIn',
    method: 'post',
    data: data
  })
}

//批量修改课程预约
export function batcheChangeBook(data) {
  return request({
    url: '/admin/user/lessons/batcheChangeBook',
    method: 'post',
    data: data
  })
}
/**
 * 商品
 * @param params
 */
export function searchGET(data) {
  return request({
    url: '/admin/goods/search',
    method: 'post',
    data: data
  })
}
/**
 * 消费
 * @param params
 */
export function borrowGoodsGET(data) {
  return request({
    url: '/admin/user/lessons/borrowGoods',
    method: 'post',
    data: data
  })
}

/**
 * 查看固定课列表
 * @param params
 */
export function searchRegulerBook(params) {
  return request({
    url: '/admin/regular/search',
    method: 'get',
    params: params
  })
}

/**
 * 固定课预约
 * @param params
 */
export function regulerBook(data) {
  return request({
    url: '/admin/regular/book',
    method: 'post',
    data: data
  })
}

/**
 * 删除固定预约
 * @param params
 */
export function deleteRegulerBook(params) {
  return request({
    url: '/admin/regular/del',
    method: 'get',
    params: params
  })
}

//借用物品
export function borrowGoods(data) {
  return request({
    url: '/admin/user/lessons/borrowGoods',
    method: 'post',
    data: data
  })
}

/**
 * 删除固定预约
 * @param params
 */
export function detailGET(params) {
  return request({
    url: '/admin/regular/detail',
    method: 'get',
    params: params
  })
}

/**
 * 查询一天发布的课程
 * @param params
 */
export function qLessonsGET(params) {
  return request({
    url: '/admin/releaselesson/qlDayReleaseLessons',
    method: 'get',
    params: params
  })
}

//查询老师接口
export function selectAllGET(params) {
  return request({
    url: '/admin/worker/selectAll',
    method: 'get',
    params: params
  })
}
//查询当前门店教室
export function releaselessonGET(params) {
  return request({
    url: '/admin/releaselesson/selectAll',
    method: 'GET',
    params: params
  })
}

//亲子预约-老师分配/洗澡分配
export function teacherAllotPOST(data) {
  return request({
    url: '/admin/releaselesson/teacherAllot',
    method: 'post',
    data: data
  })
}

//提交跟进记录
export function commitRecord(data) {
  return request({
    url: '/admin/follow/addFollow',
    method: 'post',
    data: data
  })
}


// WEBPACK FOOTER //
// ./src/api/userBookLesson.js